export default "__VITE_ASSET__8d874ec9__"